/** @jsx h */
import { h } from "preact";
export function Heading(props) {
    const { level, id, className, children } = props;
    const HeadingTag = level;
    return (h(HeadingTag, { id: id, className: className }, children));
}
export default Heading;
